import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'bell': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faBell" */
        '@fortawesome/free-regular-svg-icons/faBell'
    ),
    'compass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCompass" */
        '@fortawesome/free-regular-svg-icons/faCompass'
    ),
    'credit-card': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCreditCardAlt" */
        '@fortawesome/free-regular-svg-icons/faCreditCardAlt'
    ),
    'file': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFile" */
        '@fortawesome/free-regular-svg-icons/faFile'
    ),
    'file-image': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFileImage" */
        '@fortawesome/free-regular-svg-icons/faFileImage'
    ),
    'file-video': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFileVideo" */
        '@fortawesome/free-regular-svg-icons/faFileVideo'
    ),
    'folder': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFolderBlank" */
        '@fortawesome/free-regular-svg-icons/faFolderBlank'
    ),
    'folder-closed': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFolderClosed" */
        '@fortawesome/free-regular-svg-icons/faFolderClosed'
    ),
    'grin-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinAlt" */
        '@fortawesome/free-regular-svg-icons/faGrinAlt'
    ),
    'hospital': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHospitalWide" */
        '@fortawesome/free-regular-svg-icons/faHospitalWide'
    ),
    'id-card': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faIdCard" */
        '@fortawesome/free-regular-svg-icons/faIdCard'
    ),
    'money-bill-1': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMoneyBillAlt" */
        '@fortawesome/free-regular-svg-icons/faMoneyBillAlt'
    ),
    'money-bill-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMoneyBillAlt" */
        '@fortawesome/free-regular-svg-icons/faMoneyBillAlt'
    ),
    'star': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faStar" */
        '@fortawesome/free-regular-svg-icons/faStar'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>